import { createTheme, ThemeProvider } from '@mui/material/styles';
import { CssBaseline } from "@mui/material";
import {
  RouterProvider,
} from "react-router-dom";
import router from './router'
import {useEffect} from "react";
import axios from "./functions/requestInterceptor";
import styled from '@emotion/styled'
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const theme = createTheme({
  typography: {
    fontFamily: 'IRANSans'
  },
});

const AppContainer = styled.div`
  display: flex;
  background: #e5e5e5;
  align-items: center;
  justify-content: center;
  height: 100vh;
  @media only screen and (max-width: 1000px) {
    height: ${window.innerHeight}px;
  }
`

function App() {
  useEffect(() => {
    localStorage.setItem('tab', '')
    localStorage.setItem('search', '')
    localStorage.setItem('filter', '')
    localStorage.setItem('sort', 'newest')
    axios.get(`/metadata/`)
     .then((response) => {
       localStorage.setItem('metadata', JSON.stringify(response.data.data))
     })
     .catch(() => {
       console.log('error')
     });
  }, [])

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <AppContainer>
        <RouterProvider router={router} />
        <ToastContainer />
      </AppContainer>
    </ThemeProvider>
  );
}

export default App;
